(function () {
  'use strict';

  angular.module('sempraWebapp').factory('reportActions', reportActionsFactory);

  /** @ngInject */
  function reportActionsFactory($q, api, dispatcher, ActionTypesEnum) {
    return {
      updateReportFilter: updateReportFilter,
      getFinancesByDate: getFinancesByDate,
      getTotalR2WByDate: getTotalR2WByDate,
      getAvgByHours: getAvgByHours,
      getAvgMoneyByDay: getAvgMoneyByDay,
      getAvgMoneyByBox: getAvgMoneyByBox,
      getCoinsByDate: getCoinsByDate,
      getTotalEuroKeyByDate: getTotalEuroKeyByDate,
      getComparationFinances: getComparationFinances,
      getTotalUsersByGroupsAndDate: getTotalUsersByGroupsAndDate,
      getUsersPerVisitCount: getUsersPerVisitCount,
      getTotalSpentLocalTokensPerDay: getTotalSpentLocalTokensPerDay,
      getLoyaltyPerPaymentMethodForPeriod: getLoyaltyPerPaymentMethodForPeriod,
      getTotalTokenPaymentsByDate: getTotalTokenPaymentsByDate,
      getTotalPurchasedLocalTokensPerDay: getTotalPurchasedLocalTokensPerDay,
      getTotalGivenLocalTokensPerDay: getTotalGivenLocalTokensPerDay,
      getTotalTokenCount: getTotalTokenCount,
      getChangerIncomePerDate: getChangerIncomePerDate,
      getPosIncome: getPosIncome,
      getAllReportConfigurations: getAllReportConfigurations,
      getSelectedReportConfiguration: getSelectedReportConfiguration,
      executeDynamicReport: executeDynamicReport,
      deleteReportsData: deleteReportsData
    };

    function updateReportFilter(
      fromTimestamp,
      toTimestamp,
      serialNumber,
      period1From,
      period1To,
      period2From,
      period2To,
      period3From,
      period3To,
      currency
    ) {
      dispatcher.dispatch({
        type: ActionTypesEnum.UPDATE_REPORT_FILTER,
        payload: {
          fromTimestamp: fromTimestamp,
          toTimestamp: toTimestamp,
          selectedFacilitySerial: serialNumber,
          period1From: period1From,
          period1To: period1To,
          period2From: period2From,
          period2To: period2To,
          period3From: period3From,
          period3To: period3To,
          currency: currency
        }
      });
    }

    function getLoyaltyPerPaymentMethodForPeriod(fromTimestamp, toTimestamp) {
      var deferred = $q.defer();
      api.getLoyaltyPerPaymentMethodForPeriod(fromTimestamp, toTimestamp).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function getTotalSpentLocalTokensPerDay(fromTimestamp, toTimestamp) {
      var deferred = $q.defer();
      api.getTotalSpentLocalTokensPerDay(fromTimestamp, toTimestamp).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function getTotalGivenLocalTokensPerDay(fromTimestamp, toTimestamp) {
      var deferred = $q.defer();
      api.getTotalGivenLocalTokensPerDay(fromTimestamp, toTimestamp).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function getTotalPurchasedLocalTokensPerDay(fromTimestamp, toTimestamp) {
      var deferred = $q.defer();
      api.getTotalPurchasedLocalTokensPerDay(fromTimestamp, toTimestamp).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function getUsersPerVisitCount(fromTimestamp, toTimestamp) {
      var deferred = $q.defer();
      api.getVisitsCountForPeriod(fromTimestamp, toTimestamp).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function getTotalUsersByGroupsAndDate(fromTimestamp, toTimestamp) {
      var deferred = $q.defer();
      api.getTotalByUserGroupsForPeriod(fromTimestamp, toTimestamp).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function getFinancesByDate(
      deviceSerial,
      fromTimestamp,
      toTimestamp,
      currency
    ) {
      var deferred = $q.defer();
      api
        .getFinancesByDate(deviceSerial, fromTimestamp, toTimestamp, currency)
        .then(
          function (data) {
            deferred.resolve(data);
          },
          function (errorData) {
            dispatcher.dispatch({
              type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
              payload: errorData
            });
          }
        );

      return deferred.promise;
    }

    function getTotalR2WByDate(
      deviceSerial,
      fromTimestamp,
      toTimestamp,
      currency
    ) {
      var deferred = $q.defer();
      api
        .getTotalR2WByDate(deviceSerial, fromTimestamp, toTimestamp, currency)
        .then(
          function (data) {
            deferred.resolve(data);
          },
          function (errorData) {
            dispatcher.dispatch({
              type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
              payload: errorData
            });
          }
        );

      return deferred.promise;
    }

    function getAvgByHours(deviceSerial, fromTimestamp, toTimestamp, currency) {
      var deferred = $q.defer();
      api
        .getAvgMoneyByHours(deviceSerial, fromTimestamp, toTimestamp, currency)
        .then(
          function (data) {
            deferred.resolve(data);
          },
          function (errorData) {
            dispatcher.dispatch({
              type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
              payload: errorData
            });
          }
        );

      return deferred.promise;
    }

    function getAvgMoneyByDay(
      deviceSerial,
      fromTimestamp,
      toTimestamp,
      currency
    ) {
      var deferred = $q.defer();
      api
        .getAvgMoneyByDay(deviceSerial, fromTimestamp, toTimestamp, currency)
        .then(
          function (data) {
            deferred.resolve(data);
          },
          function (errorData) {
            dispatcher.dispatch({
              type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
              payload: errorData
            });
          }
        );

      return deferred.promise;
    }

    function getAvgMoneyByBox(
      deviceSerial,
      fromTimestamp,
      toTimestamp,
      currency
    ) {
      var deferred = $q.defer();
      api
        .getAvgMoneyByBox(deviceSerial, fromTimestamp, toTimestamp, currency)
        .then(
          function (data) {
            deferred.resolve(data);
          },
          function (errorData) {
            dispatcher.dispatch({
              type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
              payload: errorData
            });
          }
        );

      return deferred.promise;
    }

    function getCoinsByDate(deviceSerial, fromTimestamp, toTimestamp) {
      var deferred = $q.defer();
      api.getTotalCoinsByDate(deviceSerial, fromTimestamp, toTimestamp).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function getTotalTokenPaymentsByDate(fromTimestamp, toTimestamp) {
      var deferred = $q.defer();
      api.getTotalTokenPaymentsByDate(fromTimestamp, toTimestamp).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function getTotalTokenCount(fromTimestamp, toTimestamp) {
      var deferred = $q.defer();
      api.getTotalTokenCount(fromTimestamp, toTimestamp).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function getTotalEuroKeyByDate(deviceSerial, fromTimestamp, toTimestamp) {
      var deferred = $q.defer();
      api.getTotalEuroKeyByDate(deviceSerial, fromTimestamp, toTimestamp).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function getComparationFinances(
      facilityPointId,
      fromTimestamp1,
      toTimestamp1,
      fromTimestamp2,
      toTimestamp2
    ) {
      var deferred = $q.defer();
      api
        .getComparationForPeriod(
          facilityPointId,
          fromTimestamp1,
          toTimestamp1,
          fromTimestamp2,
          toTimestamp2
        )
        .then(
          function (data) {
            deferred.resolve(data);
          },
          function (errorData) {
            dispatcher.dispatch({
              type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
              payload: errorData
            });
          }
        );

      return deferred.promise;
    }

    function getChangerIncomePerDate(
      selectedFacilitySerial,
      fromTimestamp,
      toTimestamp,
      currency
    ) {
      var deferred = $q.defer();
      api
        .getChangerIncomePerDate(
          selectedFacilitySerial,
          fromTimestamp,
          toTimestamp,
          currency
        )
        .then(
          function (data) {
            deferred.resolve(data);
          },
          function (errorData) {
            dispatcher.dispatch({
              type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
              payload: errorData
            });
          }
        );

      return deferred.promise;
    }

    function getPosIncome(
      selectedFacilitySerial,
      fromTimestamp,
      toTimestamp,
      currency
    ) {
      var deferred = $q.defer();
      api
        .getPosIncome(
          selectedFacilitySerial,
          fromTimestamp,
          toTimestamp,
          currency
        )
        .then(
          function (data) {
            deferred.resolve(data);
          },
          function (errorData) {
            dispatcher.dispatch({
              type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
              payload: errorData
            });
          }
        );

      return deferred.promise;
    }

    function getAllReportConfigurations() {
      var deferred = $q.defer();
      api.getAllReportConfigurations().then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function getSelectedReportConfiguration(configurationId) {
      var deferred = $q.defer();
      api.getSelectedReportConfiguration(configurationId).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function executeDynamicReport(configurationId, data) {
      var deferred = $q.defer();
      api.executeDynamicReport(configurationId, data).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function deleteReportsData(companyId) {
      var deferred = $q.defer();
      api.deleteReportsData(companyId).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

  }
})();
